module.exports = __webpack_public_path__ + "img/41.4.NH3-N.572bc87a.png";